import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Grid,
  Snackbar,
  Alert,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import { vendorApi } from "../../api/api";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import SecondaryButton from "../common/SecondaryButton";
import GradientButton from "../common/GradiantButton";

const EditProperty = () => {
  const location = useLocation();
  const theme = useSelector((data) => data.themeValue.colors);
  const { propertyData } = location.state;
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    PropertyName: propertyData[0]?.PropertyName || "",
    Address: propertyData[0]?.Address || "",
    City: propertyData[0]?.City || "",
    SizeInSqFt: propertyData[0]?.SizeInSqFt || "",
    UnitPrice: propertyData[0]?.SqFtPrice || "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const fd=new FormData();
  fd.append("PropertyId",propertyData[0].id);
  fd.append("PropertyName",formData.PropertyName);
  fd.append("Address",formData.Address);
  fd.append("City",formData.City);
  fd.append("SizeInSqFt",formData.SizeInSqFt);
  fd.append("SqFtPrice",formData.UnitPrice);
  const handleSubmit = async () => {
    try {
      const response = await vendorApi.updatePropertyById(fd);
      setSnackbarMessage("Property updated successfully.");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Failed to update property", error);
      setSnackbarMessage("Failed to update property.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  const handleCancel = () => {
    setFormData({
      PropertyName: propertyData?.PropertyName || "",
      Address: propertyData?.Address || "",
      City: propertyData?.City || "",
      SizeInSqFt: propertyData?.SizeInSqFt || "",
      UnitPrice: propertyData?.SqFtPrice || "",
    });
    navigate(-1);

  };

  return (
    <Paper elevation={3} sx={{ maxWidth: 600, mx: "auto", p: 4, mt: 2, backgroundColor: theme.background }}>
      <Typography variant="h5" mb={3} color="primary" sx={{ color: theme.text }}>
        Edit Property
      </Typography>
      <Grid container spacing={2}>

        <TextField
          label="Property Name"
          name="PropertyName"
          fullWidth
          value={formData.PropertyName}
          onChange={handleChange}
          sx={{
            // mb: 3,
            input: {
              color: theme.text,
            },
            label: {
              color: theme.text,
            },
            '& label.Mui-focused': {
              color: theme.primary_color,
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
            },
          }}
        />

        <TextField
          label="Address"
          name="Address"
          fullWidth
          value={formData.Address}
          onChange={handleChange}
          sx={{
            // mb: 3,
            input: {
              color: theme.text,
            },
            label: {
              color: theme.text,
            },
            '& label.Mui-focused': {
              color: theme.primary_color,
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
            },
          }}
        />


        <TextField
          label="City"
          name="City"
          fullWidth
          value={formData.City}
          onChange={handleChange}
          sx={{
            // mb: 3,
            input: {
              color: theme.text,
            },
            label: {
              color: theme.text,
            },
            '& label.Mui-focused': {
              color: theme.primary_color,
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
            },
          }}
        />

        <TextField
          label="Size (Sq Ft)"
          name="SizeInSqFt"
          type="number"
          fullWidth
          value={formData.SizeInSqFt}
          onChange={handleChange}
          sx={{
            // Label (default and focused)
            '& .MuiInputLabel-root': {
              color: theme.text,
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: theme.primary_color,
            },

            // Input text color (even when disabled)
            '& .MuiInputBase-input.Mui-disabled': {
              color: theme.text,
              WebkitTextFillColor: theme.text, // Needed for Safari to override disabled gray
            },

            // Outlined border color (default, hover, focused, and disabled)
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-disabled fieldset': {
                borderColor: theme.text, // 👈 override default gray border
              },
            },
          }}
        />

        <TextField
          label="Price per Sq Ft"
          name="UnitPrice"
          type="number"
          fullWidth
          disabled
          value={formData.UnitPrice}
          onChange={handleChange}
          sx={{
            // Label (default and focused)
            '& .MuiInputLabel-root': {
              color: theme.text,
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: theme.primary_color,
            },

            // Input text color (even when disabled)
            '& .MuiInputBase-input.Mui-disabled': {
              color: theme.text,
              WebkitTextFillColor: theme.text, // Needed for Safari to override disabled gray
            },

            // Outlined border color (default, hover, focused, and disabled)
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: theme.text,
              },
              '&:hover fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-focused fieldset': {
                borderColor: theme.primary_color,
              },
              '&.Mui-disabled fieldset': {
                borderColor: theme.text, // 👈 override default gray border
              },
            },
          }}
        />


        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
          <SecondaryButton text="Cancel"
          onClick={handleCancel}
          width="50%"/>
          <GradientButton
          text="Submit"
          onClick={handleSubmit}
          width="50%"/>
        </Grid>
      </Grid>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default EditProperty;
